import TemplateGallery from "../../commonComponents/CC_templateGallery";
import SnippetsGrid from '../../components/snippetsGrid';
import { Link } from "react-router-dom";
import {linkStyle} from "../../components/helpersStyles";
import { IconButton, Tooltip } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';

export default function ProductHomeMoodMeter() {
    return <div>
            <CcTitle>
                Mood Meter
            </CcTitle>
            <div className="text-ccColorDarkTeal">Monitor recipient email satisfaction with this auto-updating rating feature.</div>
            <Link to={`/workflow/7`} style={linkStyle}> 
                <CcCreateNewSnippet className="mt-4" >Create new Mood Meter</CcCreateNewSnippet>
            </Link>
            <div className=" mt-3 border border-gray-300 rounded-md p-1 flex flex-col gap-2">
                <CcSubSectionTitle>Start with existing Template</CcSubSectionTitle>
                <div>
                <TemplateGallery productTypeId={7} />
                </div>
            </div>

            <CcSubSectionTitle className=" mt-6">Latest Mood Meter Elements</CcSubSectionTitle>
            <SnippetsGrid productTypeId={7}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}